import request from '../../../common/request/index.js'
const api = request.api

export default {
  page: (params) => {
    return api.post('withdraw/withdraw/page', params)
  },
  // 申请提现
    apply: (data) => {
      return api.post('withdraw/withdraw/apply', data)
    },
  
    // 审核通过
    approve: (data) => {
      return api.put('withdraw/withdraw/approve', data)
    },
  
    // 审核驳回
    reject: (data) => {
      return api.put('withdraw/withdraw/reject', data)
    },
	platformBalance: () => {
	  return api.get('withdraw/withdraw/platform/balance')
	},
	// 导出订单数据
  exportData: (params) => {
    return api.post('withdraw/withdraw/export', params, { responseType: 'blob' })
  }
}